export default "__VITE_ASSET__KdWYTNBs__"